export default "/images/JCO.jpg?87b4acf134eab3c959a291818aadb160";